import { RestClient } from '@affstore-ds/restclient'

import { EventsTypesApiPaths } from '../../../types'
import { SendEventParametersType } from './types'

export const sendEvent = async (data: SendEventParametersType, brandId: number, apiDomain: string) => {
  const client = new RestClient(EventsTypesApiPaths.PostApiV1Events, {}, apiDomain, {
    mode: 'cors',
    referrerPolicy: 'no-referrer',
  })

  const requestAction = Array.isArray(data) ? 'bulk' : 'single'
  const additionalHeaders = {
    'Content-Type': 'application/json',
    'X-Action': requestAction,
    'X-Brand-Id': String(brandId),
  }

  await client.post<SendEventParametersType, Response>('', data, additionalHeaders)
}
